import { MTLinkApi } from '~/core/api'
import type { MedcardSessionData } from '~/core/api/mtlink.api'

export const createMtlinkSession = async (payload: {
  uuid: string
  infoAnonymousToken: string
  masterAnonymousToken: string
} & MedcardSessionData) => {
  const { infoAnonymousToken, masterAnonymousToken, uuid, folderIds, femaleCalendarId, healthDiaries } = payload

  await MTLinkApi.createInfoMtlinkSession({
    anonymousToken: infoAnonymousToken,
    uuid,
    folderIds,
    femaleCalendarId,
    healthDiaries,
  })

  await MTLinkApi.createMasterMtlinkSession({
    anonymousToken: masterAnonymousToken,
    uuid,
  })
}
